// Core packages
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

// Third party packages
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { MatProgressButtonOptions } from 'mat-progress-buttons';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';

// Custom packages
import { AuthService } from 'src/app/modules/auth/auth.service';
import { User } from 'src/app/shared/models/user/user.model';
import { ApiService } from 'src/app/shared/services/api.service';
import { ConfigService } from 'src/app/shared/services/config.service';

@Component({
  selector: 'app-categories-dialog',
  templateUrl: './categories-dialog.component.html',
  styleUrls: ['./categories-dialog.component.scss']
})
export class CategoriesDialogComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  loggedUser = new User();
  lang = this.translateService.currentLang || this.translateService.defaultLang;

  // BEGIN - Add subUser form
  // BEGIN - ngx-formly
  form: FormGroup = new FormGroup({});
  model: any = {};
  fields: FormlyFieldConfig[] = [];
  options: FormlyFormOptions = {};
  // END - ngx-formly
  showBcc = false;
  injectedBody: any;
  injectedSubject: any;

  formBtnOptions: MatProgressButtonOptions = {
    active: false,
    text: this.translateService.instant('common.cta.send'),
    spinnerSize: 19,
    raised: true,
    stroked: true,
    flat: false,
    fab: false,
    buttonColor: 'primary',
    spinnerColor: 'primary',
    fullWidth: false,
    disabled: false,
    mode: 'indeterminate',
    buttonIcon: {
      fontSet: 'fal',
      fontIcon: 'fa-paper-plane',
      inline: true,
    },
  };
  attachmentBtnOptions: MatProgressButtonOptions = {
    active: false,
    text: this.translateService.instant('common.cta.attach'),
    spinnerSize: 19,
    raised: true,
    stroked: true,
    flat: false,
    fab: false,
    buttonColor: 'accent',
    spinnerColor: 'accent',
    fullWidth: false,
    disabled: false,
    mode: 'indeterminate',
    buttonIcon: {
      fontSet: 'fal',
      fontIcon: 'fa-paperclip',
      inline: true,
    },
  };
  // END - Add communication form

  dialogIsLoading = true;
  isAdmin = false;
  isMaster = false;

  /**
   * Class constructor
   */
  constructor(
    public dialogRef: MatDialogRef<CategoriesDialogComponent>,
    public chooseRecipientsDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public confirmDialog: MatDialog,
    public configService: ConfigService,

    private cookieService: CookieService,
    private translateService: TranslateService,
    private authService: AuthService,
    private apiService: ApiService, // DO NOT MOVE since it's used for 'autocomplete' field type
  ) { }

  /**
   * Init component
   *
   */
  ngOnInit(): void {
    // Get logged user data
    this.subscriptions.push(this.authService.loggedUser$.subscribe(res => this.loggedUser.setData(res)));
    if (this.authService.loggedUserRequestedRoleType$.getValue() === "admin"
      || this.authService.loggedUserRequestedRoleType$.getValue() === "operator") {
      this.isAdmin = true;
    }
    if (this.authService.loggedUserRequestedRoleType$.getValue() === "master"
      || this.authService.loggedUserRequestedRoleType$.getValue() === "collaborator") {
      this.isMaster = true;
    }

    // Get current lang
    this.lang = this.cookieService.get('lang') || this.configService.defaultLang;

    this.dialogIsLoading = false;

    // Get form initial values and init the form
    this.initForm();
  }

  /**
   * Handle component destroy
   *
   * @since 1.0.0
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Init form
   *
   * @since 1.0.0
   */
  initForm(): void {
    const categoriesOptions: any[] = [];
    const rawCategories = this.translateService.instant('suppliers.categories');
    for (const trans of Object.keys(rawCategories)) {
      categoriesOptions.push({
        label: rawCategories[trans],
        value: trans,
      });
    }

    if (
      this.data.model &&
      Array.isArray(this.data.model)
    ) {
      console.log(this.data.model)
      this.model = this.data.model;
    }

    this.fields = [
      {
        fieldGroupClassName: "row",
        fieldGroup: [
          {
            className: "col-12",
            type: 'select',
            key: 'categories',
            templateOptions: {
              label: this.translateService.instant('suppliers.search.fields.categories'),
              placeholder: this.translateService.instant('suppliers.search.fields.categories'),
              multiple: true,
              options: categoriesOptions,
            },
          },
        ],
      },
    ];
  }

  /**
   * Handle dialog closing
   *
   * @since 1.0.0
   */
  onClose(): void {
    this.dialogRef.close();
  }

  /**
   * Handle form submit
   *
   * @since 1.0.0
   */
  onFormSubmit(model: any): void {
    // // Prevent invalid form submit
    // if (this.form.invalid) {
    //   Object.keys(this.form.controls).forEach(key => {
    //     this.form.controls[key].markAsTouched();
    //   });
    //   this.toastrService.error(this.translateService.instant('common.errors.form_is_invalid'));
    //   return;
    // }
    this.dialogRef.close(model.categories);
  }
}
